import { Datasources, QueryOptions, QueryResult, ProcessedQueryResults } from '../models/DatasourcesModels';

export const processDatasourcesQueryResults = (
  queryResults: QueryResult[],
  queryOptions: QueryOptions[],
  datasources: Datasources,
): ProcessedQueryResults => {
  const loadings: Record<string, boolean> = {};
  const errors: Record<string, boolean> = {};
  const successes: Record<string, boolean> = {};
  const statuses: Record<string, string> = {};

  const data = Object.keys(datasources).reduce<Record<string, unknown>>((acc, key, index) => {
    const isEnabled = queryOptions[index]?.enabled ?? true;
    if (isEnabled) {
      const result = queryResults[index];
      const { isLoading, isError, isSuccess } = result;
      acc[key] = result;
      if (isLoading) {
        loadings[key] = true;
      }
      if (isError) {
        errors[key] = true;
      }
      if (isSuccess) {
        successes[key] = true;
      }
      statuses[key] = result.status;
    }
    return acc;
  }, {});

  const isLoading = Object.values(loadings).some(Boolean);
  const hasError = Object.values(errors).some(Boolean);

  return {
    data,
    isLoading,
    hasError,
    loadings,
    errors,
    successes,
    statuses,
  };
};
